// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"00fafa8f","453":"eb9674f5","564":"01b77bf3","739":"9a773a48"}[chunkId] + ".chunk.js";
};